export const isClientClassEnabled = () =>
  process.env.REACT_APP_CLIENT_CLASS_ENABLED === "true";
